import { createErrorNotifier } from "../errorNotifier";
import { createI18n, ILocaleCreatorInput } from "../i18n";
import { IContext } from "./types";

function createContext(
  appName: string,
  localeCreatorInput: ILocaleCreatorInput
): IContext {
  const errorNotifier = createErrorNotifier(appName);
  const intl = createI18n(localeCreatorInput);

  return {
    errorNotifier,
    locale: localeCreatorInput.locale,
    intl,
  };
}
export { createContext };
